import React from 'react';
import { PlayPauseButton } from '../../elements/PlayPauseButton/PlayPauseButton';
import { GoToLinkButton } from '../../elements/GoToLinkButton/GoToLinkButton';
import { AddToQueueButton } from '../../elements/AddToQueueButton/AddToQueueButton';
import { ShareButton } from '../../elements/ShareButton/ShareButton';
import './ClipControls.css';

export const ClipControls = ({ clip, size=35, color='#2A2A2A' }) => {
    return (
        <div className='clipControls'>
            <AddToQueueButton clip={clip}  size={`${size}px`} color={color} />
            <PlayPauseButton clip={clip} size={`${size}px`} color={color} />
            <ShareButton clip={clip} size={`${size}px`} color={color} />
            <GoToLinkButton clip={clip}  size={`${size}px`} color={color} />
        </div>
    );
};